import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Table as PrimeDataTable } from 'primeng/table';
import { MassCommService, Message, ManualRecipient, CommunicationRecord } from '../../../shared/index';

/**
 * edit a single mass comm message
 */
@Component({
  selector: 'wl-mass-comm-message-edit-profiles-add-manual',
  templateUrl: 'mass-comm-message-edit-profiles-add-manual.component.html',
  styleUrls: [],
    standalone: false
})
export class MassCommMessageEditProfilesAddManualComponent {
  public recipients: ManualRecipient[] = [];

  @ViewChild('addManualForm', { static: false }) private _addManualForm: NgForm;
  @Output() public newAdditionalEmails: EventEmitter<ManualRecipient[]> = new EventEmitter<ManualRecipient[]>();

  public submitted: boolean = false;
  public showModal = false;

  /**
   * inject
   */
  public constructor() {}

  /**
   * someone wants the add manual window to open
   */
  public start(): Promise<void> {
    this.submitted = false;
    this.recipients = [new ManualRecipient(), new ManualRecipient()];
    this.showModal = true;
    return Promise.resolve();
  }

  /**
   * add an email to the list
   */
  public add(): void {
    this.recipients.push(new ManualRecipient());
  }

  /**
   * user accepts the new emails
   */
  public accept(): void {
    // attempted submit
    this.submitted = true;

    // nope
    if (this._addManualForm.invalid) return;

    let validRecipients = this.recipients.filter(x => x.Email);
    if (validRecipients.length) this.newAdditionalEmails.emit(validRecipients);

    this.showModal = false;
  }
}
